import React from "react";
import { QuizShell } from "@/components/quiz/shared/QuizShell";
import { QuizNavBar } from "@/components/quiz/shared/QuizNavBar";
import { TurnstileProvider } from "../shared/turnstile";
import ResultsStepSummary from "./ResultsStepSummary";

type Props = {
  dogs: { id: string; form: any }[];
  activeDogId: string | null;
  onPrev: () => void;
  onNext: () => void;
};

/**
 * Screen 12 — the dog profile summary, presented with the redesigned quiz chrome
 * (blue band + dog photo ABOVE the progress tabs, per Figma frame 12 / desktop
 * profile frame). On Next it hands off to the existing results flow at the plan
 * step; Previous returns to the owner step. Reuses ResultsStepSummary so the
 * calorie/dailyGrams calc + Klaviyo sync are preserved.
 */
export function ProfileSummaryScreen({ dogs, activeDogId, onPrev, onNext }: Props) {
  return (
    <>
      <QuizShell
        activeTab={2}
        variant="profile"
        onClose={() => {
          window.location.href = "/";
        }}
      >
        <TurnstileProvider>
          <ResultsStepSummary dogs={dogs} activeDogId={activeDogId} />
        </TurnstileProvider>
      </QuizShell>
      <QuizNavBar onPrev={onPrev} onNext={onNext} nextLabel="Next" />
    </>
  );
}

export default ProfileSummaryScreen;
